export const isPublicRoute = (pathname: string) =>
  /\/change-password|\/sign-up|\/therapist-user-signup|\/providers|\/initquestions|\/forgot-password|\/reset-password|\/support|\/verify-onboarding|\/error|\/login|\/profile/.test(
    pathname,
  );

export const isShouldLoggoutRoute = (pathname: string) =>
  /\/login|\/sign-up|\/therapist-user-signup|\/forgot-password|\/reset-password|\/verify-onboarding|\/support|\/error/.test(
    pathname,
  );

export const isPrivateRoute = (pathname: string) =>
  /\/therapy|\/error|\/scheduler|\/settings|\/profile|\/intake-report|\/session-ended|\request-rematch|\/activity-log|\/meeting-info|\/reset-credentials|\/profile|\/teletherapy|\/practice-admin|\/super-admin|\/payment|\/billing-admin|\/resources/.test(
    pathname,
  );

export const isShouldLoggoutAndRedirectRoute = (pathname: string) =>
  /\/providers|\/therapist-user-signup|\/sign-up/.test(pathname);

export const isNoHeaderRoute = (pathname: string) =>
  /\/teletherapy\/meeting-room|\/teletherapy\/waiting-room|\/greetings/.test(
    pathname,
  );

// Routes that should be accessible regardless of auth state (both public and private),
export const isTokenBasedRoute = (pathname: string) =>
  /\/verification|\/_payment-consents|\/intake/.test(pathname);

/**
 * Public entry pages a signed-in user has no reason to be sitting on: landing
 * on one with a live session sends them to their own dashboard instead.
 *
 * Deliberately much narrower than isPublicRoute. A provider profile is browsable
 * while signed in and the app opens it in a new tab, /error has to stay visible,
 * and the password and onboarding flows are all reachable mid-session — bouncing
 * off any of those would break them.
 * @param {String} pathname the route being loaded
 * @returns {Boolean} true when a signed-in visitor belongs somewhere else
 */
export const isSignedInRedirectRoute = (pathname: string) =>
  pathname === '/' ||
  /\/login|\/initquestions|\/support|\/providers/.test(pathname);

export const isNonAuthRoute = (pathname: string) =>
  /^\/(sign-up|therapist-user-signup|providers|initquestions|forgot-password|reset-password|verify-onboarding|register|login)(\/|$|\?|#)/.test(
    pathname,
  );
